import * as _ from 'underscore';

import { FlowBasicInfo, FlowDetailInfo, FlowListItemInfo } from '../models/FlowInfo';
import { IUserInfo } from '../models/IUserInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { FlowBasic, FlowDetail, FlowListItem } from '../ServerApi/types/Flow';
import { IUsageInfo } from '../ServerApi/types/IUsageInfo';
import { MapperHelper } from './MapperHelper';
import { ProjectMapper } from './ProjectMapper';
import { UserMapper } from './UserMapper';

export module FlowMapper {

  const M = MapperHelper;

  export function mapBasic(
    serverApiFlows: ReadonlyArray<FlowBasic>,
    users: _.Dictionary<IUserInfo>,
    projects: _.Dictionary<INamedItemInfo> = {},
  ): FlowBasicInfo[] {
    return _.map(serverApiFlows, (f: FlowBasic) => {
      const fbInfo: FlowBasicInfo = {
        id:                        f.id,
        name:                      f.name,
        owner:                     users[f.ownerId],
        project:                   projects[f.projectId],
        contentType:               'flow',
      };
      return fbInfo;
    });
  }

  export function map(
    flows: FlowListItem[],
    users: _.Dictionary<IUserInfo>,
    projects: _.Dictionary<INamedItemInfo>,
    usageInfoMaxValues?: IUsageInfo,
    favoriteFlows: _.Dictionary<any> = {}
  ): FlowListItemInfo[] {
    return _.map(flows, (f: FlowListItem) =>
      mapOne(f, users[f.ownerId], projects[f.projectId], usageInfoMaxValues, !!favoriteFlows[f.id])
    );
  }

  export function mapOneForAlert(
    f: FlowBasic,
  ): FlowBasicInfo {
    return {
      id: f.id,
      name: f.name,
      contentType: 'flow',
    };
  }

  export function mapOne(
    f: FlowListItem,
    owner: IUserInfo,
    project: INamedItemInfo,
    usageInfoMaxValues?: IUsageInfo,
    favorite?: boolean
  ): FlowListItemInfo {
    return {
      id:                    f.id,
      inputCount:            f.inputCount,
      name:                  f.name,
      outputCount:           f.outputCount,
      owner:                 UserMapper.mapOne(owner),
      project:               project,
      description:           f.description,
      updatedAt:             M.toDate(f.updatedAt),
      favorite:              favorite,
      tags:                  M.sortTags(f.tags),
      usageInfo:             f.usageInfo,
      usageInfoMaxValues:    usageInfoMaxValues || <IUsageInfo>{},
      contentType:           'flow',
      flowFileType:          f.fileType,
      flowDocumentVersion:   f.documentVersion,
      thumbnailUrl:          f.thumbnailUrl,
      dataQualityIndicators: f.dataQualityIndicators || []
    };
  }

  export function mapDetail(f: FlowDetail): FlowDetailInfo {
    return {
      id:                    f.id,
      inputCount:            f.inputCount,
      name:                  f.name,
      outputCount:           f.outputCount,
      createdAt:             M.toDate(f.createdAt),
      description:           f.description,
      updatedAt:             M.toDate(f.updatedAt),
      downloadUrl:           f.downloadUrl,
      editUrl:               f.editUrl,
      favorite:              f.favorite,
      tags:                  M.sortTags(f.tags),
      owner:                 UserMapper.mapOne(f.owner),
      project:               ProjectMapper.mapName(f.project),
      contentType:           'flow',
      flowGraphImageUrl:     f.flowGraphImageUrl,
      flowFileType:          f.fileType,
      flowDocumentVersion:   f.documentVersion,
      hasExtracts:           f.hasExtracts,
      hasEncryptableExtracts: f.hasEncryptableExtracts,
      extractEncryptionState: f.extractEncryptionState,
      dataQualityIndicators:  f.dataQualityIndicators || [],
      luid: f.luid
    };
  }

  export function mapFromCRASS(content: any): FlowListItemInfo{
    return {
        id:                    content.id,
        inputCount:            0, //missing
        name:                  content.title,
        outputCount:           0, //missing
        project:               null, //missing
        description:           content.description,
        updatedAt:             M.toDate(content.modifiedTime),
        favorite:              false, //missing
        tags:                  M.sortTags(content.tags),
        usageInfo:             null, //missing
        usageInfoMaxValues:    <IUsageInfo>{}, //missing
        contentType:           'flow',
        flowFileType:          content.fileType,
        flowDocumentVersion:   content.version,
        thumbnailUrl:          getFlowThumbnailUrl(content.id, M.toDate(content.modifiedTime)),
        dataQualityIndicators: [], //missing
        owner: {
            id: content.ownerId + '',
            displayName: content.ownerName || '',
            username: content.ownerName || '',
            domainName: content.ownerDomain,
            isHiddenInternalUser: false
        }
      };
  }

  function getFlowThumbnailUrl(flowId: String, updatedAt: Date){
    const cacheValue = updatedAt ? updatedAt.getTime() : '';
    return M.REST_API_BASE_URL + `views/${flowId}/thumbnail?${cacheValue}`;
  }
}
